import React from 'react';
import {
  FormBody,
  FormContainer,
  FormItem,
  FormSwitch,
  FormTitle,
  Tooltip,
} from '../../components-dummy/SettingsForm';
import { AddToCart } from '../../app-state-types/reducer-state-types/add-to-cart';

interface Props {
  showSettingsForm: boolean;
  addToCart: AddToCart;
  onChange: (addToCartConfig: AddToCart) => void;
  shopId: number;
}

export function AddToCartForm({
  showSettingsForm,
  addToCart,
  onChange,
  shopId,
}: Props): JSX.Element | null {
  if (!showSettingsForm) return null;
  const path = `/shops/${shopId}/recommendation-engines/general-settings`;
  const tip = (
    <Tooltip.Text>
      Navigate to the&nbsp;
      <Tooltip.Link path={path}>Carousel settings</Tooltip.Link>
      &nbsp;page to edit the Add to Cart UI layout
    </Tooltip.Text>
  );
  return (
    <FormContainer>
      <FormTitle tip={tip}>Add to cart</FormTitle>
      <FormBody divider>
        <FormItem>
          <FormSwitch
            label='Enable add to cart'
            checked={addToCart.active}
            onChange={active => onChange({ active })}
          />
        </FormItem>
      </FormBody>
    </FormContainer>
  );
}
